module.exports = "<p>\n  forecast-cost-hour-data works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forecast-cost-hour-data/forecast-cost-hour-data.component.html
// module id = ./src/app/forecast-cost-hour-data/forecast-cost-hour-data.component.html
// module chunks = main